var exports = {
  "N": "x93eb46d8--2f97b5--card",
};

module.exports = exports;
